<template>
  <div @click="showPopup" class="rich-select bank-select">
    <span class="content" v-if="content">{{content}}</span>
    <span class="rich-select-placeholder" v-else>{{placeholder}}</span>
    <i class="rich-select-icon"></i>
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n, getBDCountry } from '@/common/utils/i18n'

const country = getBDCountry() || 'MX'
export default {
  name: 'BankSelect',
  components: {
  },
  inject: ['rootForm'],
  data () {
    return {
      content: (this.rootForm.value && this.rootForm.value.accountBankName) || '',
      options: [],
      placeholder: i18n.gettext('请输入'),
      prop: 'accountBank'
    }
  },
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'bank'
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (!this.value) return
      // 当传入的数据有值且无法与options匹配时，显示传入的默认文案
      if (this.defaultValue) {
        this.content = this.defaultValue
      }
      // 经过与后端确认，type为bankMap与bankMapFinance返回的结果经过改动后是相同的，且日本返回的是主行，可以使用相同的组件获取主行列表
      let $select = ['MX', 'BR', 'CO', 'JP', 'DO', 'CL', 'PE'].includes(country) ? this.$createFullScreenBankSelect() : null
      $select && $select.$on('initsel', (list) => {
        list.forEach(item => {
          if (item.key + '' === this.value + '') {
            this.content = item.value
          }
        })
      })
    },
    showPopup () {
      let $select = country === 'BR' || country === 'CO'
        ? this.$createFullScreenBankSelect().show()
        : this.$createFullScreenBankSearch().show()
      $select.$on('select', (data) => {
        let { key, value } = data
        this.content = value
        this.options = [{ value: key, text: value }]
        this.$emit('input', key, { prop: this.prop })
        this.rootForm.$emit('input', this.rootForm.internalData, { prop: this.prop })
        $select.hide()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-select {
  overflow: auto;

  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }

  // 组件使用rich-select需设置disabled属性点击时禁止picker弹出，但不需要disabled的样式
  ::v-deep .rich-select_disabled {
    background-color: #fff
  }

  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }

  .content{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
}
</style>
